import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/archerist/nuxt3_ogrenci/layouts/default.vue").then(m => m.default || m))
}